import React, { useState, useEffect } from "react";
import { FormControlLabel, Box, Typography, Paper } from "@mui/material";
import { updateUser } from "../../../../Actions/Users";
import { notifyError, notifySuccess } from "../../../../Utils/CustomNotifcations";
import { ServerInfo } from "../../../../Actions/serverSetting";
import Button from "../../../common/Button";
import Switch from "../../../common/Switch";

export default function TwoFactorForm(props) {
  const initialEnabled = props.selectedItem?.twoFa || false;
  const [enabled, setEnabled] = useState(initialEnabled);
  const isChanged=enabled !== initialEnabled

const userDataFormat = (data, extAttriubtes, itemId) => {
  return {
    administrator: data.userType === 1 ? false : true,
    attributes: extAttriubtes ? extAttriubtes : {},
    coordinateFormat: Array.isArray(data?.coordinateFormat) && data.coordinateFormat.length === 0
    ? ""
    : data?.coordinateFormat ?? "",  
    deviceLimit: data.deviceLimit ? data.deviceLimit : "",
    deviceReadonly:
      data.deviceReadonly === "on" || data.deviceReadonly === true
        ? true
        : false,
    disabled: data.disabled === "on" || data.disabled === true ? true : false,
    email: ("" + data.email).trim(),
    expirationTime: data.expirationTime ? data.expirationTime : null,
    id: itemId ? itemId : 0,
    latitude: data.latitude ? data.latitude : 0,
    limitCommands:
      data.limitCommands === "on" || data.limitCommands === true ? true : false,
    login: data.login,
    longitude: data.longitude ? data.longitude : 0,
    // map: data.map,
    name: ("" + data.name).trim(),
    map: Array.isArray(data.map) && data.map.length === 0 ? "" : data.map || "",
    // phone: data.phone,
    phone:
      Array.isArray(data.phone) && data.phone.length === 0
        ? ""
        : data.phone || "",
    poiLayer: data.poiLayer,
    readonly: data.readonly === "on" || data.readonly === true ? true : false,
    token: data.token,
    twelveHourFormat:
      data.twelveHourFormat === "on" || data.twelveHourFormat === true
        ? true
        : false,
    userLimit: data.userLimit ? data.userLimit : "",
    zoom: data.zoom ? data.zoom : 0,
    roleId: data.roleId || 0,
    userType: parseInt(data.userType),
    parentId: data.parentId || 0,

  };
};
  const handleSubmit = (e) => {
    e.preventDefault();

    const obj=userDataFormat(props.selectedItem,props.selectedItem.attributes,props.selectedItem.id)
    const updatedObj={
      ...obj,
      twoFa:enabled
    }

    fetch(`/api/users/${props.selectedItem.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedObj),
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((res) => {
            let account = res.data;
            if (res.status === "success") {
              props.dispatch(updateUser(account));
              props.UpdateSelectedItem(account);
              props.dispatch(notifySuccess("2FA updated successfully"));

              if (props.selectedItem.id === 1) {
                props.dispatch(ServerInfo(account));
              }
            } else if (res?.statusCode === "440") {
              window.location.replace("/login");
            } else if (res.statusCode) {
              var err = res?.message.split(":");
              err[1] = err[1].replace(")", "");
              props.dispatch(notifyError(props.translate(err[1])));
            }
          });
        } else {
          throw response;
        }
      })
      .catch(() => {
        props.dispatch(notifyError("Something went wrong"));
      });
  };

  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 2, maxWidth: 400 }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Two-Factor Authentication
      </Typography>

      <Typography variant="body2" color="text.secondary" gutterBottom>
        Enhance your account security by enabling 2FA.
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <FormControlLabel
          control={
            <Switch
              checked={enabled}

              onChange={(e) => setEnabled(e.target.checked)}
            />
          }
           label={
          <Typography fontWeight="bold">
            {enabled ? "2FA Enabled" : "2FA Disabled"}
          </Typography>
          
        }
        />
          <Box mt={2}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={!isChanged}
            >
              Save
            </Button>
          </Box>
      </Box>
    </Paper>
  );
}
